import script from "./AdminDashboardPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminDashboardPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminDashboardPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__